import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html'
})
export class ReportHeaderComponent {
  @Input() crumbLabel = '';
  @Input() crumbSuffix = 'Results';
  @Output() download = new EventEmitter<void>();
  @Output() recalculate = new EventEmitter<void>();
}
